<script setup>
import { useI18n } from 'vue-i18n';
import SettingsToggleSection from 'dashboard/components-next/Settings/SettingsToggleSection.vue';

// Card "Grupos de WhatsApp" (spec F3 §5.1, ruling 25): los 4 knobs per-cuenta del REGISTRY (default OFF). Index.vue la
// monta solo con el módulo QR activo; el modo por grupo (panel del grupo) los pisa.
defineProps({ settings: { type: Object, required: true } });
const emit = defineEmits(['update']);
const { t } = useI18n();

const KNOBS = [
  ['whatsapp_qr_group_leads', 'LEADS'],
  ['whatsapp_qr_group_auto_assign', 'AUTO_ASSIGN'],
  ['whatsapp_qr_group_auto_messages', 'AUTO_MESSAGES'],
  ['whatsapp_qr_group_bots', 'BOTS'],
];
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <h3 class="text-base font-medium text-n-slate-12">
        {{ t('MASIFI_SETTINGS.WHATSAPP_QR_GROUPS.HEADER') }}
      </h3>
      <p class="text-sm text-n-slate-11">
        {{ t('MASIFI_SETTINGS.WHATSAPP_QR_GROUPS.DESCRIPTION') }}
      </p>
    </div>
    <SettingsToggleSection
      v-for="[key, label] in KNOBS"
      :key="key"
      :model-value="Boolean(settings[key])"
      :header="t(`MASIFI_SETTINGS.WHATSAPP_QR_GROUPS.${label}.HEADER`)"
      :description="
        t(`MASIFI_SETTINGS.WHATSAPP_QR_GROUPS.${label}.DESCRIPTION`)
      "
      @update:model-value="value => emit('update', key, value)"
    />
  </div>
</template>
